// extracted by mini-css-extract-plugin
module.exports = {"conversationListHeaderNotificationIconContainer":"styles_conversationListHeaderNotificationIconContainer__GXtx2","selectionPillsContainer":"styles_selectionPillsContainer__2boFA"};